import React, { Component } from 'react'
import moment from 'moment'
import get from 'lodash/get'
import {
  Container,
  Segment,
  Header,
  Form,
  Checkbox,
  Button,
  Statistic,
} from 'semantic-ui-react'
import Datetime from 'react-datetime'
import gql from 'graphql-tag'
import { ApolloConsumer } from 'react-apollo'

const DatePicker = props => (
  <div style={{ height: 40 }}>
    <Datetime
      value={props.value}
      onChange={props.onChange}
      dateFormat="MM/DD/YYYY"
      timeFormat={false}
    />
  </div>
)

const USER_ITEMS = [
  { key: 'anonymousUsers', label: 'Anonymous Users' },
  { key: 'registeredUsers', label: 'Registered Users' },
  { key: 'scsOptInUsers', label: 'SCS Opted In Users' },
  { key: 'scsEligibleUsers', label: 'SCS Eligible Users' },
]

const MISSING_ITEMS = [
  { key: 'missingEmails', label: 'Missing Email' },
  { key: 'missingPhones', label: 'Missing Phone No.' },
  { key: 'missingZipCodes', label: 'Missing Zip' },
  { key: 'missingInsurance', label: 'Missing Insurance' },
]

const StatisticRow = ({ items, ...props }) => {
  return (
    <Statistic.Group style={{ justifyContent: 'space-between' }}>
      {items.map(item => (
        <Statistic key={item.label}>
          <Statistic.Label>{item.label}</Statistic.Label>
          <Statistic.Value>{item.value}</Statistic.Value>
        </Statistic>
      ))}
    </Statistic.Group>
  )
}

class Home extends Component {
  state = {
    startTime: '',
    endTime: '',
    allTime: false,
    metrics: null,
  }

  handleToggle = (e, { name, checked }) => {
    this.setState({ [name]: checked })
  }

  handleChangeFrom = mt => {
    this.setState({ startTime: mt.format('MM/DD/YY') })
  }

  handleChangeTo = mt => {
    this.setState({ endTime: mt.format('MM/DD/YY') })
  }

  formatTimes = () => {
    let times = {}

    if (this.state.startTime) {
      times.startTime = +moment(this.state.startTime).format('x')
    }

    if (this.state.endTime) {
      times.endTime = +moment(this.state.endTime).format('x')
    }

    return times
  }

  onMetricsFetched = ({ metrics }) => {
    this.setState({ metrics })
  }

  render() {
    const { endTime, startTime, allTime, metrics } = this.state

    const userItems = USER_ITEMS.map(item => ({
      ...item,
      value: get(metrics, `[${item.key}]`, 0),
    }))
    const missingItems = MISSING_ITEMS.map(item => ({
      ...item,
      value: get(metrics, `[${item.key}]`, 0),
    }))

    return (
      <Container>
        <Segment padded>
          <Header as="h1">SCS Funnel Metrics</Header>

          <Form>
            <Form.Group style={{ alignItems: 'center' }}>
              <div style={{ marginRight: 32 }}>
                <Form.Field
                  control={DatePicker}
                  name="startTime"
                  label="Start Time"
                  value={startTime}
                  onChange={this.handleChangeFrom}
                />
              </div>
              <Form.Field
                control={DatePicker}
                name="endTime"
                label="End Time"
                value={endTime}
                onChange={this.handleChangeTo}
              />
            </Form.Group>
            <Form.Field
              control={Checkbox}
              toggle
              name="allTime"
              label="All Time"
              checked={allTime}
              onChange={this.handleToggle}
            />
            <ApolloConsumer>
              {client => {
                return (
                  <Button
                    primary
                    content="Fetch"
                    onClick={async () => {
                      const variables = this.state.allTime
                        ? null
                        : this.formatTimes()
                      const { data } = await client.query({
                        query: USER_METRICS_QUERY,
                        variables,
                      })
                      this.onMetricsFetched(data)
                    }}
                  />
                )
              }}
            </ApolloConsumer>
          </Form>

          <Segment>
            <StatisticRow items={userItems} />
            <StatisticRow items={missingItems} />
          </Segment>
        </Segment>
      </Container>
    )
  }
}

export const USER_METRICS_QUERY = gql`
  query UserMetrics($startTime: Float, $endTime: Float) {
    metrics(startTime: $startTime, endTime: $endTime) {
      anonymousUsers
      registeredUsers
      scsOptInUsers
      scsEligibleUsers
      missingEmails
      missingPhones
      missingZipCodes
      missingInsurance
    }
  }
`

export default Home
